import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ec72125"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "allcourse" }
const _hoisted_2 = { class: "selectbox" }
const _hoisted_3 = { class: "statelist" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "类别：", -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "statelist" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "状态：", -1))
const _hoisted_8 = { style: {"color":"red"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupsLabelslist.groups, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.id,
            onClick: ($event: any) => (_ctx.groupchange(item)),
            class: _normalizeClass({'active': _ctx.selectedgroups[0] === item.groupCode})
          }, _toDisplayString(item.groupName), 11, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_a_checkbox_group, {
          value: _ctx.selectedlabels,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedlabels) = $event)),
          options: _ctx.groupsLabelslist.labels,
          onChange: _ctx.checkechange
        }, {
          label: _withCtx((labels) => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(labels.groupName), 1)
          ]),
          _: 1
        }, 8, ["value", "options", "onChange"])
      ])
    ]),
    _createVNode(_component_a_spin, {
      tip: "加载中...",
      spinning: _ctx.loading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.list.length)
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 0,
                gutter: 22,
                span: 6,
                courses: _ctx.list,
                onJumpToCourse: _ctx.gotoCourseDetail
              }, null, 8, ["courses", "onJumpToCourse"]))
            : (_openBlock(), _createBlock(_component_Nodata, {
                key: 1,
                class: "nodata",
                mode: "vertical",
                customdesc: '暂无内容'
              }))
        ])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}